export default __webpack_public_path__ + "static/media/ram.19510ef8.svg";